import { render, staticRenderFns } from "./hist-impexpgraph-tm-1pmc.vue?vue&type=template&id=08c71042&"
import script from "./hist-impexpgraph-tm-1pmc.vue?vue&type=script&lang=js&"
export * from "./hist-impexpgraph-tm-1pmc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
